import { ArrowBackIcon, ContentCopyIcon } from "@/icons";
import {
  OrionChoiceDialogue,
  type OrionChoiceDialogueChoice,
} from "@/orion/OrionComponents/OrionChoiceDialogue";

type DuplicateGuardChoice = "duplicate" | "choose-different";

const CHOICES: OrionChoiceDialogueChoice<DuplicateGuardChoice>[] = [
  {
    id: "duplicate",
    title: "Duplicate Tile",
    description:
      "Create a copy of this tile so each variation can be measured independently.",
    icon: <ContentCopyIcon sx={{ fontSize: 96 }} />,
  },
  {
    id: "choose-different",
    title: "Choose a Different Tile",
    description: "Go back and select a different tile for this variation.",
    icon: <ArrowBackIcon sx={{ fontSize: 96 }} />,
  },
];

interface AbDuplicateGuardModalProps {
  open: boolean;
  onClose: () => void;
  tileName: string;
  onTileNameChange: (value: string) => void;
  tileNameError: string;
  isPending: boolean;
  onSelect: (choiceId: DuplicateGuardChoice) => void;
}

export function AbDuplicateGuardModal({
  open,
  onClose,
  tileName,
  onTileNameChange,
  tileNameError,
  isPending,
  onSelect,
}: AbDuplicateGuardModalProps) {
  return (
    <OrionChoiceDialogue<DuplicateGuardChoice>
      open={open}
      onClose={onClose}
      title="This tile is already in use"
      subtitle="Another variation is already using this tile. Would you like to duplicate it or choose a different one?"
      inputLabel="Duplicate Tile Name"
      inputPlaceholder="e.g. Spring Promo (B)"
      inputValue={tileName}
      onInputChange={onTileNameChange}
      inputError={tileNameError}
      inputDisabled={isPending}
      choices={CHOICES.map((c) => ({
        ...c,
        disabled: isPending,
      }))}
      onSelect={onSelect}
    />
  );
}
